import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./EnergySavingCTA.module.scss";
import classnames from "classnames/bind";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import { YourekoMedal } from "@/components/EnergySaving/useYourekoLabels.ts";
import { ChevronRightOutlined as ChevronRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";

const cx = classnames.bind(styles);

const GBP = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const imageBaseUrl = "https://static.johnlewiscontent.com/v1/static";
export const FALLBACK_MEDAL_URL = `${imageBaseUrl}/none-button-v2`;

export const ratingMedalMap: Record<YourekoMedal, string> = {
  Best: `${imageBaseUrl}/platinum-button-v2%20(1)`,
  Gold: `${imageBaseUrl}/gold-button-v2`,
  Silver: `${imageBaseUrl}/silver-button-v2`,
  Bronze: `${imageBaseUrl}/bronze-button-v2`,
  "Good value": `${imageBaseUrl}/plain-button-v2`,
};

type Props = {
  onClick: () => void;
  medalRatingText: YourekoMedal;
  numberOfAlternatives: number;
  energyCostSavingUnformatted: number;
};

export function getTitle(energyCostSavingUnformatted: number) {
  if (!Number.isFinite(energyCostSavingUnformatted)) return "No energy saving";

  if (energyCostSavingUnformatted <= 0) return "No energy saving";

  return `${GBP.format(energyCostSavingUnformatted)} energy saving`;
}

function getMedalURL(medalRatingText: YourekoMedal) {
  return ratingMedalMap[medalRatingText] || FALLBACK_MEDAL_URL;
}

export function EnergySavingCTA({
  onClick,
  medalRatingText,
  numberOfAlternatives,
  energyCostSavingUnformatted,
}: Props) {
  return (
    <SecondaryButton
      onClick={onClick}
      className={cx("energySavingCTA")}
      size="medium"
    >
      <div className={cx("medalWrapper")}>
        <img
          className={cx("medal")}
          src={formatAmplienceImageURL(getMedalURL(medalRatingText))}
          alt={`${medalRatingText || ""} rating`}
        />
      </div>
      <span className={cx("savingText")}>
        {getTitle(energyCostSavingUnformatted)}
        {numberOfAlternatives > 0 && (
          <span className={cx("alternativesNo")}>
            <span className={cx("seperator")}>|</span>
            Found {numberOfAlternatives} cheaper to run
          </span>
        )}
      </span>
      <ChevronRight size="medium" />
    </SecondaryButton>
  );
}

export default EnergySavingCTA;
